'use client';
import { css } from 'styled-system/css'

export const sidebarStyle = {
	leftMenu: css({
		color: 'black.2',
	}),
	sideTabs: css({
		height: 'auto',
	}),
	liveSwitch: css({
		padding: '0px',
		height: '30px',
		borderRadius: '6px',
		backgroundColor: 'liveSwitch.bg',
		boxShadow: 'inset 0 0 0 1px var(--colors-black-5)',
		_after: {
			display: 'none'
		},
	}),
	liveSwitchBtn: css({
		padding: '0 12px',
		color: 'black.3',
		'&[data-selected=true]': {
			backgroundColor: 'liveSwitch.selectedBg',
			fontWeight: '700',
			color: 'liveSwitch.selectedText',
		},
	}),
	sideMenu: css({
		paddingBottom: 0,
		_after: {
			display: 'none'
		}
	}),
	sideMenuTitle: css({
		display: 'flex',
		height: '30px',
		padding: '6px 15px',
		alignItems: 'flex-start',
		gap: '10px',
		alignSelf: 'stretch',
		color: 'black.3',
		fontSize: '12px',
		fontWeight: '700',
		lineHeight: '15px',
	}),
	sideMenuItem: css({
		'&[data-open="true"]': {
			bg: 'white.3',
		},
	}),
	arrowDownIcon: css({
		color: 'black.3',
		width: '21px',
		height: '21px'
	}),
	sideSubMenu: css({
		borderTop: '1px solid',
		borderColor: 'black.5',
		bgColor: 'transparent',
	}),
	sideSubMenuBtn: css({
		_hover: {
			bgColor: 'white.3',
		}
	}),
	streamerButton: css({
		marginRight: '-6px',
	}),
	sidebarItemSelected: css({
		color: 'brand.500_light',
	}),
	sideMenuBadge: css({
		lineHeight: 'initial',
		flex: '0 0 auto',
		fontSize: '12px',
		padding: '3px',
		borderRadius: '6px',
		color: 'black.2',
		minWidth: '21px',
		backgroundColor: 'black.5',
		'[data-selected=true]>&': {
			color: 'sideMenuBtn.selectedBadge.text',
			backgroundColor: 'sideMenuBtn.selectedBadge.bg',
		},
	}),
	sideFeaturesItem: css({
		height: 'auto',
	})
}
